/*
 * @Author: your name
 * @Date: 2020-07-17 16:45:31
 * @LastEditTime: 2020-07-17 16:45:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\Base\index.js
 */ 
// BLL基类
export default class Base {
    constructor(vm) {
        this.vm = vm;
    }
}
